"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hardforks = [
    ['chainstart', require('./chainstart.json')],
    ['homestead', require('./homestead.json')],
    ['dao', require('./dao.json')],
    ['tangerineWhistle', require('./tangerineWhistle.json')],
    ['spuriousDragon', require('./spuriousDragon.json')],
    ['byzantium', require('./byzantium.json')],
    ['constantinople', require('./constantinople.json')],
    ['petersburg', require('./petersburg.json')],
    ['istanbul', require('./istanbul.json')],
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-common/dist/hardforks/index.js
// module id = 1229
// module chunks = 0 1 2